const SCHEMA_REFRESH_STARTER_KITS = ['google-bigquery-streaming'];

export default SCHEMA_REFRESH_STARTER_KITS;
